import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const StatItem = ({
  end,
  suffix,
  label,
  duration = 2
}: {
  end: number;
  suffix: string;
  label: string;
  duration?: number;
}) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (isInView) {
      let startTime: number;
      const step = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
        // easeOutQuart
        const easeProgress = 1 - Math.pow(1 - progress, 4);
        setCount(Math.floor(easeProgress * end));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          setCount(end);
        }
      };
      window.requestAnimationFrame(step);
    }
  }, [isInView, end, duration]);
  return <div ref={ref} className="flex flex-col items-center justify-center p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors group" data-id="element-168">
      <div className="text-4xl md:text-5xl font-display font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 drop-shadow-[0_0_15px_rgba(6,182,212,0.4)] mb-2 group-hover:scale-110 transition-transform" data-id="element-169">
        {count}
        {suffix}
      </div>
      <div className="text-gray-400 font-medium text-lg" data-id="element-170">{label}</div>
    </div>;
};
export function Stats() {
  return <section className="py-20 relative z-10" data-id="element-171">
      <div className="max-w-7xl mx-auto px-6" data-id="element-172">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-173">
          <StatItem end={12} suffix="" label="שיגורים מוצלחים" data-id="element-174" />
          <StatItem end={40} suffix="+" label="לוויינים במסלול" data-id="element-175" />
          <StatItem end={99} suffix=".8%" label="אחוז הצלחה" data-id="element-176" />
          <StatItem end={8} suffix="" label="שנות פעילות" data-id="element-177" />
        </div>
      </div>
    </section>;
}